import { useMutation } from '@tanstack/react-query';
import { createProductFeedback } from '../../services/productFeedback.service';

export const useCreateProductFeedback = () => useMutation({
  mutationFn: async (data: Parameters<typeof createProductFeedback>[0]) => {
    const response = await createProductFeedback(data);
    return response.data.data;
  },
  retry: false,
});
